'use strict';

let processInclude = require('base/util');

$(document).ready(function () {
	// onPopState is replaced by plpUrlState: the base one loops forever on URLs with a hash.
	processInclude(Object.assign({}, require('base/search/search'), { onPopState: null }));
	processInclude(require('./search/contentTab'));
	processInclude(require('./search/searchResultCount'));
	processInclude(require('./search/searchNoResultsMostPopular'));
	processInclude(require('./search/plpUrlState'));
	processInclude(require('./search/filterModal'));
	processInclude(require('./search/quickFilters'));
	processInclude(require('./components/productPackSelect'));
	processInclude(require('./components/notifyMe'));
	processInclude(require('./search/productTileCart'));
});
